import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { CTASection } from "@/components/common/CTASection";
import { IMAGES } from "@/lib/site";
import { Target, Eye } from "lucide-react";

export default function About() {
  const { L } = useLang();
  const P = L.pages.about;
  usePageSeo("about");
  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: L.nav.about }]}
      />

      <section className="py-20 lg:py-28">
        <div className="container-tight grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="overline mb-3">{P.storyOverline}</p>
            <h2 className="font-heading text-3xl font-semibold text-ink">{P.storyTitle}</h2>
            <p className="mt-4 leading-relaxed text-subtle">{P.story1}</p>
            <p className="mt-4 leading-relaxed text-subtle">{P.story2}</p>
          </div>
          <img src={IMAGES.skyline} alt="Global financial centres" className="rounded-2xl border border-hair object-cover shadow-md" />
        </div>
      </section>

      <section className="bg-canvas py-20 lg:py-28">
        <div className="container-tight grid gap-6 md:grid-cols-2">
          <div className="rounded-xl border border-hair bg-white p-8 shadow-sm">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-navy text-gold"><Target className="h-6 w-6" strokeWidth={1.5} /></span>
            <h3 className="mt-5 font-heading text-xl font-semibold text-ink">{P.missionT}</h3>
            <p className="mt-3 leading-relaxed text-subtle">{P.mission}</p>
          </div>
          <div className="rounded-xl border border-hair bg-white p-8 shadow-sm">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-navy text-gold"><Eye className="h-6 w-6" strokeWidth={1.5} /></span>
            <h3 className="mt-5 font-heading text-xl font-semibold text-ink">{P.visionT}</h3>
            <p className="mt-3 leading-relaxed text-subtle">{P.vision}</p>
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="container-tight">
          <SectionHeading overline={P.valuesOverline} title={P.valuesTitle} />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {P.values.map((v) => (
              <div key={v[0]} className="rounded-xl border border-hair bg-white p-6 shadow-sm">
                <h3 className="font-heading text-lg font-semibold text-ink">{v[0]}</h3>
                <p className="mt-2 text-sm text-subtle">{v[1]}</p>
              </div>
            ))}
          </div>
          <div className="mt-10"><Button asChild variant="outline"><Link to="/why-menagroupfx">{P.whyLink}</Link></Button></div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
